import {useEffect,useRef} from 'react'
import {withRouter} from 'react-router-dom'
let GoogleTracker = props => {
  const { history,children } = props;
  const trackerListener = useRef(null)
  useEffect(()=>{
    trackerListener.current = history.listen(() => {
      window.dataLayer.push({event: 'pageview'});
    });
    return (()=>{
      if(trackerListener.current){
        trackerListener.current()
      }
    })
  },[history])
  return (
    children
  )
}

/**********************************************************************************************************
 *   COMPONENT END
 **********************************************************************************************************/
export default withRouter(GoogleTracker);